import React, { useEffect, useState } from "react";
import "../../styles/home/hero-section.scss";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../config/firebase";

const HeroSection = () => {
    const [current, setCurrent] = useState(0);
    const [carousel, setCarousel] = useState([]);

    useEffect(() => {
        const heroRef = collection(db, "heroes");
        // Check if heroes are already cached in sessionStorage
        const cachedHeroes = sessionStorage.getItem("home_heroes");
        if (cachedHeroes) {
            setCarousel(JSON.parse(cachedHeroes));
        } else {
            // Fetch heroes from Firebase and cache them
            const getHero = async () => {
                try {
                    const data = await getDocs(heroRef);
                    const sortedData = data.docs
                        .map((doc) => doc.data())
                        .sort((a, b) => a.order - b.order);
                    setCarousel(sortedData);
                    sessionStorage.setItem("home_heroes", JSON.stringify(sortedData));
                } catch (error) {
                    console.error("Error fetching heroes:", error);
                }
            };
            getHero();
        }
    }, []);

    const leftArrowClick = () => {
        setCurrent((current - 1 + carousel.length) % carousel.length);
    };

    const rightArrowClick = () => {
        setCurrent((current + 1) % carousel.length);
    };

    const renderIndicators = () => {
        return carousel.map((item, index) => (
            <div
                key={index}
                className={`indicator ${index === current ? "active" : ""}`}
                onClick={() => setCurrent(index)}
            >
                <div />
            </div>
        ));
    };

    const renderInner = () => {
        return carousel.map((item, index) => {
            // Only load images for current slide and adjacent slides
            const isNearby = 
                index === current || 
                Math.abs(index - current) <= 1 || 
                (index === 0 && current === carousel.length - 1) || 
                (index === carousel.length - 1 && current === 0);

            return (
                <div
                    className={`item ${index === current ? "" : "hidden"}`}
                    key={index}
                >
                    {isNearby && (
                        <img 
                            src={item.url} 
                            alt={item.title} 
                            loading={index === 0 ? "eager" : "lazy"} 
                            fetchPriority={index === 0 ? "high" : "auto"}
                            decoding="async" 
                        />
                    )}
                    <div className="caption">
                        <div className="title">{item.title}</div>
                        <div className="description">{item.description}</div>
                    </div>
                </div>
            );
        });
    };

    return (
        <div className="hero-section">
            <div className="carousel">
                {renderInner()}
                <div className="indicators">{renderIndicators()}</div>
            </div>
            <div className="left no-select" onClick={leftArrowClick} role="button" aria-label="Previous slide" tabIndex={0} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && leftArrowClick()}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
                </svg>
            </div>
            <div className="right no-select" onClick={rightArrowClick} role="button" aria-label="Next slide" tabIndex={0} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && rightArrowClick()}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z" />
                </svg>
            </div>
        </div>
    );
};

export default HeroSection;
